import { render, staticRenderFns } from "./TransactionsPage.vue?vue&type=template&id=394abb24&"
import script from "./TransactionsPage.vue?vue&type=script&lang=ts&"
export * from "./TransactionsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports